import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FieldConfigDTO } from '../../../../../system/system-dtos';

@Component({
  selector: 'app-column-filter',
  templateUrl: './column-filter.component.html',
  styleUrls: ['./column-filter.component.scss'],
  standalone: false,
})
export class ColumnFilterComponent implements OnInit {
  showColumns = false;

  @Input() allColumns: FieldConfigDTO[] = [];

  @Input() selectedColumns: string[] = [];

  @Output() selectedColumnsChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  constructor() {}

  ngOnInit(): void {}

  onModelChange() {
    console.log(this.selectedColumns);
  }

  onClickedOutside($event: Event) {
    const previous = this.showColumns;
    this.showColumns = false;
    if (previous) {
      this.emitValue();
    }
  }

  private emitValue() {
    this.selectedColumnsChange.emit(this.selectedColumns.map((c) => c));
  }

  reset() {
    this.selectedColumns = [];
    this.emitValue();
  }

  toggleList() {
    const previous = this.showColumns;
    this.showColumns = !this.showColumns;
    if (previous) {
      this.emitValue();
    }
  }
}
